// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3JB48","inputDescription":"styles_inputDescription__3HYUa"};